'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var GridHeaders = exports.GridHeaders = undefined;

exports.GridHeaders = GridHeaders = function GridHeaders(config) {
    return Ext.create('Ext.toolbar.Toolbar', $.extend(config, {
        cls: 'd2analysis-gridheaders'
    }));
};
//# sourceMappingURL=GridHeaders.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/GridHeaders.js
 ** module id = 58
 ** module chunks = 0 1
 **/